export function pushGAEvent(gaObject) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gaObject);
}
